const UpdateButton = ({ onUpdate }) => {
  return (
    <button className="srup-btn " onClick={onUpdate} title="Update">
      Update
    </button>
  );
};

export default UpdateButton;
